/*************************************
 *
 * 自定义工具类
 * Author:smallsix@66629
 *
 *************************************/

import Md5 from 'js-md5'
import {getLocalStorage} from './webCache'

/**
 * 文字大于指定长度后 用...隐藏
 *
 * @param text
 * @param textShowLength
 *
 * @returns {string|*}
 */
export function textExceedHide (text, textShowLength) {
  if (text.length > textShowLength) {
    return text.substr(0, textShowLength) + '...'
  }
  return text
}

/**
 * 针对时间时个位数的时候 前面补0
 *
 * @param n
 * @returns {string}
 */
export function formatNumber (n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}

/**
 * 时间格式化 时间戳 =》 中国时间
 *
 * @param timestamp 时间戳
 * @param format 时间格式
 *
 * @returns {string|string}
 */
export function fromTime (timestamp, format = 'Y-M-D h:m:s') {
  let time = new Date(timestamp * 1000)
  let newArr = []
  let formatArr = ['Y', 'M', 'D', 'h', 'm', 's']

  newArr.push(time.getFullYear())
  newArr.push(formatNumber(time.getMonth() + 1))
  newArr.push(formatNumber(time.getDate()))
  newArr.push(formatNumber(time.getHours()))
  newArr.push(formatNumber(time.getMinutes()))
  newArr.push(formatNumber(time.getSeconds()))

  for (let i in newArr) {
    format = format.replace(formatArr[i], newArr[i])
  }

  return format
}

/**
 * 倒计时
 *
 * @param h
 * @param m
 * @param s
 *
 * @returns {*|boolean}
 */
export function countDown (expireTime) {
  const newTimestamp = Date.parse(new Date()) / 1000 - Number(getLocalStorage('time'))
  const time = expireTime - newTimestamp
  if (time < 0) {
    return false
  }
  const h = formatNumber(parseInt(time / 60 / 60 % 24))
  const m = formatNumber(parseInt(time / 60 % 60))
  const s = formatNumber(parseInt(time % 60))

  return h + ':' + m + ':' + s
}

export function countDownSenconds (expireTime) {
  if (expireTime < 0) {
    return false
  }
  const h = formatNumber(parseInt(expireTime / 60 / 60 % 24))
  const m = formatNumber(parseInt(expireTime / 60 % 60))
  const s = formatNumber(parseInt(expireTime % 60))

  return h + ':' + m + ':' + s
}

/**
 * 倒计时
 *
 * @param h
 * @param m
 * @param s
 *
 * @returns {*|boolean}
 */
export function countDownTime (expireTime) {
  const newTimestamp = Math.round(new Date() / 1000) - Number(getLocalStorage('time'))
  const time = parseInt(expireTime - newTimestamp)

  if (time < 0) {
    return {
      d: 0,
      h: 0,
      m: 0,
      s: 0
    }
  }
  const d = formatNumber(parseInt(time / (60 * 60 * 24)))
  const h = formatNumber(parseInt(time / 60 / 60 % 24))
  const m = formatNumber(parseInt(time / 60 % 60))
  const s = formatNumber(parseInt(time % 60))

  let date = {
    d: d,
    h: h,
    m: m,
    s: s
  }

  return date
}
/**
 * 验证码倒计时
 *
 * @param h
 * @param m
 * @param s
 *
 * @returns {*|boolean}
 */
export function countDownSeconds (seconds) {
  seconds--
  return seconds
}
/**
 * 倒计时
 *
 * @param h
 * @param m
 * @param s
 *
 * @returns {*|boolean}
 */
export function countDownFun (endTime) {
  const newTimestamp = Date.parse(new Date()) / 1000
  const time = endTime - newTimestamp
  if (time < 0) {
    return false
  }
  const d = formatNumber(parseInt(time / (60 * 60 * 24)))
  const h = formatNumber(parseInt(time / 60 / 60 % 24))
  const m = formatNumber(parseInt(time / 60 % 60))
  const s = formatNumber(parseInt(time % 60))

  let date = {
    d: d,
    h: h,
    m: m,
    s: s
  }

  return date
}
/**
 * 新版倒计时
 *
 * @param expireTime
 * @returns {string|boolean}
 */
export function countDownNew (expireTime) {
  const newTimestamp = Date.parse(new Date()) / 1000
  const time = expireTime - newTimestamp
  if (time < 0) {
    return false
  }
  const h = formatNumber(parseInt(time / 60 / 60 % 24))
  const m = formatNumber(parseInt(time / 60 % 60))
  const s = formatNumber(parseInt(time % 60))

  return {
    h: h,
    m: m,
    s: s
  }
}

export function countDownTimer (time) {
  if (time < 0) {
    return false
  }
  const h = formatNumber(parseInt(time / 60 / 60 % 24))
  const m = formatNumber(parseInt(time / 60 % 60))
  const s = formatNumber(parseInt(time % 60))

  return {
    h: h,
    m: m,
    s: s
  }
}

/**
 * 验证手机号码
 *
 * @param mobile
 *
 * @returns {boolean}
 */
export function verifyMobile (mobile) {
  const myreg = /^[1][3,4,5,7,8][0-9]{9}$/
  if (!myreg.test(mobile)) {
    return false
  }
  return true
}

/**
 * 生成 Api 签名参数
 *
 * @param params
 * @param key
 *
 * @returns {*}
 */
export function getSign (params, key) {
  if (typeof params === 'string') {
    return paramSort(params, key)
  } else if (typeof params === 'object') {
    let arr = []
    for (let i in params) {
      if (params.hasOwnProperty(i)) {
        let p = i + '='
        Array.isArray(params[i]) ? p += '[' + params[i] + ']' : p += params[i]
        arr.push(p)
      }
    }
    console.log(arr)
    return paramSort(arr.join(('&')), key)
  }
}

/**
 * 加密参数
 *
 * @param paramsStr
 * @param key
 *
 * @returns {*}
 */
function paramSort (paramsStr, key) {
  let url = paramsStr + '&key=' + key
  let urlStr = url.split('&').sort().join('&')
  let urlParams = urlStr.toLocaleLowerCase()
  return Md5(urlParams)
}

/**
 * 判断是否微信浏览器 true => 是，false => 不是
 *
 * @returns {boolean}
 */
export function isWechat () {
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf('micromessenger') > 1) {
    return true
  }
  return false
}

/**
 * 函数 防抖
 *
 * @type {function(...[*]=)}
 */
export const debounce = (function () {
  let timer = null
  return function (fn, delay = 500) {
    clearTimeout(timer)
    timer = setTimeout(fn, delay)
  }
})()

/**
 * 获取当前运行环境的标识
 *
 * @returns {string}
 */
export function getUserAgent () {
  return navigator.userAgent.toLowerCase()
}

/**
 * 判断是否是webview
 *
 * @returns {boolean}
 */
export function isWebView () {
  let userAgent = navigator.userAgent.toLowerCase()
  if (userAgent.includes('ypcappuseragent')) {
    return true
  }
  return false
}

/**
 * 判断当前环境是否是小程序
 *
 * @returns {boolean}
 */
export function isMiniProgram () {
  let userAgent = navigator.userAgent.toLowerCase()
  if (userAgent.includes('miniProgram')) {
    return true
  }
  return false
}

/**
 * 判断是否是安卓手机
 *
 * @returns {boolean}
 */
export function isAndroid () {
  let userAgent = navigator.userAgent.toLowerCase()
  if (userAgent.match(/iPhone\sOS/i) === 'iphone os') {
    return false
  } else {
    return true
  }
}

export function getQueryString (name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

/**
 * 删除对象中 字段为空的字段
 *
 * @param obj
 */
export function deleteObjNullKey (obj) {
  let objKey
  for (objKey in obj) {
    if (obj[objKey] !== 0 && !obj[objKey]) delete (obj[objKey])
  }
  return obj
}



// WEBPACK FOOTER //
// ./src/utils/customUtils.js